import { useLazyQuery } from '@apollo/client';
import { FilterHandle } from '@access-erp/common';
import { MutableRefObject } from 'react';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { CustomerFilterInput, CustomerLookupFilterInput, CustomerLookupSort, CustomerLookupSortSortByInput }
  from '@/graphql/contracts/_generated_/contracts';
import { GetCustomers, GetCustomersVariables } from '@/graphql/contracts/_generated_/getCustomers.query';
import { notificationService } from '@/services/notification/notification.client';
import GetCustomersQuery from '@/graphql/contracts/getCustomers.query.gql';
import { ALL_ITEMS } from '@/config/common.config';

export type CustomersInput = {
  after: string;
  first: number;
  sort: CustomerLookupSortSortByInput[];
  filter: CustomerLookupFilterInput;
  group: CustomerLookupSort;
  before: string;
  last: number;
};

export default function useGetDetails() {
  const [_getCustomers, { loading, error }] = useLazyQuery<GetCustomers, GetCustomersVariables>(
    GetCustomersQuery,
    {
      client: apolloClientContracts,
      fetchPolicy: 'network-only',
      onError: (err) =>
        notificationService.open({
          title: 'Error',
          text: err.message,
          type: 'danger',
        }),
    },
  );

  const getChildCustomers = async (
    customerID: string,
    filtersRef: MutableRefObject<FilterHandle>,
  ) => {
    const detailFilters: CustomerFilterInput = filtersRef?.current?.applyToDetail
      ? (filtersRef.current?.mappedDetailFilters as CustomerFilterInput)
      : {};
    const customers = await _getCustomers({
      variables: {
        filter: { ...detailFilters, parentCustomerID: { eq: customerID } },
        first: ALL_ITEMS,
      },
    });

    const customersWithId =
            customers?.data?.customerGrid?.masterRecords?.customers?.items?.map((el) => ({
              ...el,
              id: el?.customerID,
            })) ?? [];

    return {
      data: customersWithId,
      loading,
    };
  };

  return {
    getChildCustomers,
    isLoadingGetChildCustomers: loading,
    error,
  } as const;
}
